export default {
    qualitativeNotes: [],
    qualitativeNotesLoading: false,
    reportItemPlateOrders: [],
    reportItemPlateOrdersLoading: false,
    reportItemPlates: [],
    reportItemPlatesLoading: false,
    codes: [],
    filters: setInitialQualitativeNotesFilters(),
    setInitialQualitativeNotesFilters: setInitialQualitativeNotesFilters,
    reportItemPlateFilters: setInitialReportItemPlateFilters(),
    setInitialReportItemPlateFilters: setInitialReportItemPlateFilters,
}

function setInitialQualitativeNotesFilters() {
    return {
        reportedBy_id: null,
        authorizedBy_id: null,
        productionProcess_id: null,
        responsiblePerson_id: null,
        code_id: null,
        createdAt__gte: null,
        createdAt__lte: null,
        search: null
    }
}

function setInitialReportItemPlateFilters() {
    return {
        reportItemPrimaryNumber: null
    }
}